/* eslint-disable */
// import { useNavigate } from "react-router-dom";
import React from "react";
import styled from "styled-components";
import logo from "../assets/logo-typo.png";

const SPACING = "40px";
const HEIGHT = "65px";

function Header({ ScrollTop, onMoveBusinessBox, onMoveMissionBox }) {
  //   const navigate = useNavigate();
  return (
    <Base>
      <Container>
        <LogoBox>
          <Logo onClick={ScrollTop} src={logo} />
          {/* <LogoTitle>미래플랜트엔지니어링</LogoTitle> */}
        </LogoBox>
      </Container>
    </Base>
  );
}
export default Header;

const Base = styled.div`
  width: 100%;
  height: ${HEIGHT};
`;
const Container = styled.div`
  width: 100%;
  height: ${HEIGHT};
  position: fixed;
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* border-bottom: 0.2px solid #808180; */
  background-color: rgba(255, 255, 255, 0.6);
  -webkit-backdrop-filter: blur(45px);
  backdrop-filter: blur(45px);
`;
const LogoBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
`;
const Logo = styled.img`
  width: 120px;
  height: auto;
  margin: 0 0 0 ${SPACING};
  cursor: pointer;
  @media screen and (max-width: 500px) {
    margin: 0 0 0 20px;
    width: 110px;
    height: auto;
  }
`;
const LogoTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: black;
`;
const LabelBox = styled.div`
  flex-direction: row;
  margin: 0 ${SPACING} 0 0;
  @media screen and (max-width: 500px) {
    margin: 0 10px 0 0;
  }
`;
const Label = styled.span`
  color: ${(props) => (props.active ? "#6BB9FF" : "#707070")};
  &:hover {
    color: #2e4d78;
    transition: 0.5s;
  }
  font-size: 16px;
  margin: 0 20px 0 0;
  cursor: pointer;
  font-weight: 500;
`;
